import type { SVGProps } from "react";
export interface BellRingingOffIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function BellRingingOffIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: BellRingingOffIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M17.874 10.843V9.5a5.875 5.875 0 0 0-6.911-5.783l-.114.013a1.124 1.124 0 0 1-.282-2.23l.352-.054A8.125 8.125 0 0 1 20.124 9.5v1.343a1.125 1.125 0 0 1-2.25 0m.83-9.638a1.126 1.126 0 0 1 1.506-.078l.085.078.405.419c.876.947 1.745 2.15 2.266 3.698l.114.364.026.112a1.125 1.125 0 0 1-2.149.624l-.038-.108-.085-.271c-.39-1.16-1.05-2.095-1.785-2.89l-.344-.358-.078-.085a1.126 1.126 0 0 1 .078-1.505ZM14 20.875l.116.005a1.125 1.125 0 0 1 0 2.239l-.116.006h-4a1.125 1.125 0 0 1 0-2.25zm-9.501-20c.298 0 .584.119.795.33l17.5 17.5.079.085a1.126 1.126 0 0 1-1.584 1.582l-.085-.076-1.324-1.324a2.6 2.6 0 0 1-.882.153H5.001c-2.32 0-3.5-2.792-1.882-4.456l.224-.23.122-.137c.264-.331.41-.744.41-1.17V9.5c0-1.837.61-3.533 1.64-4.894l-.978-.977c-.618.754-1.15 1.629-1.457 2.685l-.037.108A1.125 1.125 0 0 1 .92 5.686l.113-.364c.601-1.785 1.665-3.112 2.67-4.117l.172-.141c.183-.122.4-.189.624-.189m1.626 12.256c0 .94-.32 1.848-.902 2.575l-.265.302-.226.23a.376.376 0 0 0 .27.637h12.782L7.125 6.217c-.632.938-1 2.067-1 3.283z"
      />
    </svg>
  );
}
